module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--reward-order t-modal is-visible"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--reward-order__box"
  }, [_c('div', {
    staticClass: "c-modal--reward-order__box__content"
  }, [_c('h1', {
    staticClass: "c-modal--reward-order__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_confirmation.sucess_message')))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--reward-order__confirmation-message u-paragraph u-center-text"
  }, [_vm._v(_vm._s(_vm.orderConfirmationMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__actions"
  }, [_c('button', {
    staticClass: "c-button c-modal--reward-order__actions__button t-button-plain",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_order_confirmation.back_button')) + "\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "c-button c-modal--reward-order__actions__button t-button-primary",
    attrs: {
      "to": {
        name: 'MyOrders'
      },
      "tag": "button"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_order_confirmation.my_orders_link')) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6dae8b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/OrderConfirmation.vue
// module id = 566
// module chunks = 1